import React, { ReactNode } from 'react';
import {
  Box,
  Stack,
  Typography,
  Button,
  useTheme
} from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';



export type MilestoneDetailCardLayoutProps = {
  title: string;
  subTitle: string;
  children: ReactNode;
  actionButton: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  } | null;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MilestoneDetailCardLayoutProps) => {
  const theme = useTheme();
  return (
    <Box
      display='flex'
      flexDirection='column'
      border={`1px solid ${theme.palette.secondary.dark}`}
      borderRadius='1.25rem'
      padding='1.25rem'
      rowGap='1rem'
    >
      {/* HEADER */}
      <Stack
        paddingX='1rem'
        rowGap='.25rem'
      >
        <Typography
          variant='modalTitle'
        >
          {props.title}
        </Typography>
        <Typography
          variant='modalSubTitle'
        >
          {props.subTitle}
        </Typography>
      </Stack>

      {/* DETAIL */}
      <Stack
        padding='1rem'
        rowGap='1rem'
      >
        {props.children}
      </Stack>


      {/* ACTIONS */}
      {props.actionButton && (

        <Box
          margin='auto'
        >
          <Button
            variant='text'
            color='primary'
            disabled={props.actionButton.disabled}
            onClick={() => props.actionButton && props.actionButton.onClick()}
            startIcon={(
              <CustomIcon.large.FC
                icon='PLUS'
                stroke={(
                  props.actionButton.disabled
                    ? theme.palette.grey[300]
                    : theme.palette.primary.main
                )}
              />
            )}
          >
            {props.actionButton.text}

          </Button>
        </Box>
      )}
    </Box>
  );
};
